import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { DataService } from "../base-data-services/data.service";
import { stateListModel } from "common/models/page-models/custom-model/state.model";



@Injectable()
export class stateListDataService extends DataService<stateListModel> {
    stateList: any = []
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.stateList,http);
    }


//    override getAPI_URL(): API_URL {
//         return API_URL.getDocumentTypeList;
//       }
    
    createInstance():stateListModel  {
        return new stateListModel();
    }

    getStateList(){
        this.postData({}).then((data) => {
            this.stateList = data.details;
            // return data.details.filter((state) => state.id === id)[0].stateName;
        });
    }

    getStateNameById(id) {
        const filteredState = this.stateList.filter((state) => state.id === id)
        return filteredState.length > 0 ? filteredState[0].stateName: '';

    }

}
